export default "__VITE_ASSET__Zb8vextm__"